// extracted by mini-css-extract-plugin
export var getStarted = "index-module--getStarted--3SPAa";
export var getStarted__text = "index-module--getStarted__text--zsrfR";
export var getStarted__button = "index-module--getStarted__button--Gcdy+";